var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "purchase_part-subheader" },
    [
      _c(
        "b-col",
        {
          staticClass: "d-flex align-items-center px-1",
          attrs: { lg: "3", sm: "6", xs: "12" },
        },
        [
          _vm.purchase.type === "fl44_unknown_volume"
            ? _c("span", { staticClass: "fs-12 green-color" }, [
                _vm._v(" Цена контракта: "),
                _c("span", { staticClass: "fw-600 ws-nowrap" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$formatPrice(
                        _vm.purchase.purchase_info.contract_price
                      )
                    ) + " руб."
                  ),
                ]),
              ])
            : _c("span", { staticClass: "fs-12 green-color" }, [
                _vm._v(" НЦК: "),
                _c("span", { staticClass: "fw-600 ws-nowrap" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$formatPrice(_vm.purchase.purchase_info.start_price)
                    ) + " руб."
                  ),
                ]),
              ]),
        ]
      ),
      _vm.isPurchasePubliclyAvailable
        ? [
            _c(
              "b-col",
              {
                staticClass: "d-flex align-items-center px-1",
                attrs: { lg: "3", sm: "6", xs: "12" },
              },
              [
                _c("span", { staticClass: "fs-12 green-color" }, [
                  _vm._v(" Предложений: "),
                  _vm.purchase.flags.is_hidden
                    ? _c("span", { staticClass: "fw-600 ws-nowrap" }, [
                        _vm._v(" Скрыто"),
                      ])
                    : _c("span", { staticClass: "fw-600 ws-nowrap" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.purchase.type === "fl44"
                                ? _vm.purchase.purchase_info
                                    .purchase_actual_offers_count
                                : _vm.purchase.purchase_info
                                    .purchase_actual_proposals_count
                            )
                        ),
                      ]),
                ]),
              ]
            ),
            [
              _c(
                "b-col",
                {
                  staticClass: "d-flex align-items-center px-1",
                  attrs: { lg: "3", sm: "6", xs: "12" },
                },
                [
                  _vm.purchase.type === "fl44"
                    ? _c("span", { staticClass: "fs-12 green-color" }, [
                        _vm._v(" Лучшее: "),
                        _vm.purchase.flags.is_hidden
                          ? _c("span", { staticClass: "fw-600 ws-nowrap" }, [
                              _vm._v(" Скрыто"),
                            ])
                          : _c("span", { staticClass: "fw-600 ws-nowrap" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.purchase.purchase_info
                                      .purchase_min_offer_cost
                                      ? _vm.$formatPrice(
                                          _vm.purchase.purchase_info
                                            .purchase_min_offer_cost
                                        ) + " руб."
                                      : "—"
                                  ) +
                                  " "
                              ),
                            ]),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "b-col",
                {
                  staticClass: "d-flex align-items-center px-1",
                  attrs: { lg: "3", sm: "6", xs: "12" },
                },
                [
                  _vm.purchase.type === "fl44"
                    ? _c("span", { staticClass: "fs-12 green-color" }, [
                        _vm._v(" Снижение: "),
                        _vm.purchase.flags.is_hidden
                          ? _c("span", { staticClass: "fw-600 ws-nowrap" }, [
                              _vm._v(" Скрыто"),
                            ])
                          : _c("span", { staticClass: "fw-600 ws-nowrap" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.purchase.purchase_info
                                      .economy_percentage
                                      ? _vm.purchase.purchase_info
                                          .economy_percentage + "%"
                                      : "—"
                                  )
                              ),
                            ]),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }